/**
 * The formatters the pathway surfaces share (catalogue, landing, player, portal section,
 * admin report).
 *
 * TWO KINDS OF DATE CROSS THIS WIRE, and they must not share a formatter:
 *
 *   - CALENDAR DATES (`start_date`): "YYYY-MM-DD", no
 *     time, no zone. `new Date("2026-10-01")` parses that as UTC MIDNIGHT, so a reader west
 *     of Greenwich was shown "September 30" for a pathway starting on October 1. A calendar
 *     date is formatted AS a calendar date: built from its three parts and printed in UTC,
 *     so it reads the same day everywhere.
 *   - INSTANTS (`enrolled_at`, `completed_at`, `unlock_at`,
 *     announcement `created_at`): ISO-8601 with an offset, shown in the
 *     reader's own zone.
 *
 * Absent or unreadable input returns "" — callers render nothing rather than "Invalid Date".
 */
import { dateLocale } from "../i18n/dateLocale";

const YMD = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * @param {string|null} ymd  "YYYY-MM-DD" or null
 * @param {string}      lang product language ("fr" | "en" | "es")
 * @returns {string} e.g. "1 oct. 2026" / "Oct 1, 2026"; "" when absent or malformed
 */
export const fmtCalendarDate = (ymd, lang) => {
  const m = typeof ymd === "string" ? YMD.exec(ymd) : null;
  if (!m) return "";
  const ms = Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  if (!Number.isFinite(ms)) return "";
  return new Date(ms).toLocaleDateString(dateLocale(lang), {
    dateStyle: "medium",
    timeZone: "UTC",
  });
};

/**
 * @param {string|null} iso  ISO-8601 instant or null
 * @param {string}      lang product language
 * @returns {string} the reader-local date; "" when absent or unreadable
 */
export const fmtInstantDate = (iso, lang) => {
  if (!iso) return "";
  const ms = Date.parse(iso);
  return Number.isFinite(ms)
    ? new Date(ms).toLocaleDateString(dateLocale(lang), { dateStyle: "medium" })
    : "";
};
